export default __webpack_public_path__ + "static/media/market-ru.8dc3ece7.webp";